import { Navigation } from '@src/routing/Navigation';
import { useSearchParams } from 'react-router-dom';

export const DEFAULT_PAGE_SIZE = 100;
export const FIRST_PAGE = 0;

export const useCurrentPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const currentPage = Number(
    searchParams.get(Navigation.orderList.pageSearchParamKey) ?? FIRST_PAGE,
  );
  const pageSize = Number(
    searchParams.get(Navigation.orderList.pageSizeSearchParamKey) ??
      DEFAULT_PAGE_SIZE,
  );

  const setCurrentPage = (page: number) => {
    searchParams.set(Navigation.orderList.pageSearchParamKey, page.toString());
    setSearchParams(searchParams);
  };

  const setPageSize = (pageSize: number) => {
    searchParams.set(
      Navigation.orderList.pageSizeSearchParamKey,
      pageSize.toString(),
    );
    setSearchParams(searchParams);
  };

  return { currentPage, pageSize, setCurrentPage, setPageSize };
};
